




import { defineComponent } from "@vue/composition-api";
import { number, string } from "@/v2/util/prop/type";

/**
 * @deprecated
 * use `AtomIcon` from `v2/new-design-system` instead
 */

export default defineComponent({
  name: "AtomIcon",
  props: {
    name: string().isRequired().use(),
    color: string().setDefault("currentColor").use(),
    size: number().setDefault(16).use(),
  },
  computed: {
    iconSize(): { width: string; height: string } {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
      };
    },
    icon() {
      // template literals doesn't work well with dynamic import on jest
      return () =>
        import(
          /* webpackChunkName: "icon-[request]" */ "./assets/" +
            this.name +
            ".svg"
        );
    },
  },
});
